import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class UserGroupGuard extends Component {
  render() {
    const { group, type, children } = this.props;
    const match = (Array.isArray(type) && type.find(type => group === type) !== undefined) || type === group;

    return <div>
      {match && children}
    </div>
  }
}

UserGroupGuard.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
};

const mapStateToProps = (state) => ({
  group: state.viewConfig.profile.attributes['user-group'],
});

export default connect(mapStateToProps)(UserGroupGuard);



// WEBPACK FOOTER //
// ./src/components/common/guards/user-group.jsx